import React from 'react'
import { Dialog, DialogContent, Typography } from '@mui/material'
import Button from 'components/Common/Button'
import { useNavigate } from 'react-router-dom'

const sx = {
    dialog: {
        borderRadius: '20px',
        textAlign: 'center',
        width: '500px',
        padding: '50px',
    },
}

const MobileSubscriptionDialog = () => {
    const navigate = useNavigate()
    return (
        <Dialog open={true} style={{ zIndex: 2000 }} PaperProps={{ style: sx.dialog }}>
            <DialogContent>
                <Typography variant="body1">
                    Since your subscription was initially set-up on a mobile device, please use your mobile application to
                    manage it.
                </Typography>
                <Button sx={{ width: '250px', marginTop: '50px' }} onClick={() => navigate('/')}>
                    Close
                </Button>
            </DialogContent>
        </Dialog>
    )
}

export default MobileSubscriptionDialog